// Environment configuration
export type Environment = 'PRODUCTION' | 'STAGING' | 'DEVELOPMENT';
export const Environments = {
  PRODUCTION: {
    name: 'PRODUCTION',
    displayName: 'Production',
    apiBaseUrl: 'https://api-wp.shopifyconnect.bezohminds.app/',
    color: '#00e676' // Green for production
  },
  STAGING: {
    name: 'STAGING',
    displayName: 'Staging',
    apiBaseUrl: 'https://api-uat-wp.shopifyconnect.bezohminds.app/',
    color: '#ffab00' // Orange/Yellow for staging
  },
  DEVELOPMENT: {
    name: 'DEVELOPMENT',
    displayName: 'Development',
    apiBaseUrl: 'https://api-dev-wp.shopifyconnect.bezohminds.app/', // 'http://localhost:5000/', // Default development URL
    color: '#ff4081' // Pink for development
  }
};

// Current environment - Change this to switch between environments
export const CurrentEnvironment: Environment = 'DEVELOPMENT';

export const AppConfig = {
  appName: 'Shopify Connect', // Application label used throughout the UI
  environment: CurrentEnvironment as Environment,
  currentEnvConfig: Environments[CurrentEnvironment],
  apiBaseUrl: Environments[CurrentEnvironment].apiBaseUrl, // Dynamically set based on current environment
  theme: {
    primaryColor: '#00b0ff',
    accentColor: '#ff4081',
    successColor: '#00e676',
    warningColor: '#ffab00',
    errorColor: '#ff1744',
    infoColor: '#00b0ff'
  },
  pagination: {
    pageSize: 10
  },
  statuses: {
    synced: 'Synced',
    pending: 'Pending',
    failed: 'Failed'
  },
  scheduler: {
    timezone: 'EST (Eastern Standard Time)',
    timezoneShort: 'EST'
  },
  collections: {
    columns: {
      'TYPE': 'Type',
      'TAG': 'Tag'
    },
    relations: {
      'CONTAINS': 'contains',
      'NOT_CONTAINS': 'does not contain',
      'EQUALS': 'is equal to',
      'NOT_EQUALS': 'is not equal to',
      'STARTS_WITH': 'starts with',
      'ENDS_WITH': 'ends with',
      'GREATER_THAN': 'greater than',
      'LESS_THAN': 'less than',
      'IS_SET': 'is set',
      'IS_NOT_SET': 'is not set'
    },
    sortOrders: {
      'ALPHA_ASC': 'Alphabetical (A-Z)',
      'ALPHA_DESC': 'Alphabetical (Z-A)',
      'BEST_SELLING': 'Best selling',
      'CREATED': 'Created date (oldest first)',
      'CREATED_DESC': 'Created date (newest first)',
      'MANUAL': 'Manual order',
      'PRICE_ASC': 'Price (low to high)',
      'PRICE_DESC': 'Price (high to low)'
    }
  }
};
